import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PrivateRoutes } from "./allRoutes";
import { isAuthenticated } from "../shared/services/auth";

const Auth = () => {
  return isAuthenticated() ? (
    <Outlet />
  ) : (
    <Navigate to="/auth/login" />
  );
};

export const ProtectedRoutes = () => {
  return (
    <Routes>
      <Route element={<Auth />}>
        <Route path="/dashboard" element={<Navigate to="/dashboard/home" replace />} />
        {PrivateRoutes.map((route, key) => (
          <Route key={key} path={route.path} element={route.element} >
            {route?.children?.map((child, childKey) => (
              <Route key={childKey} path={child.path} element={child.element} />
            ))}
          </Route>
        ))}
      </Route>
    </Routes>
  );
};
